import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconNewTag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 5,
		cy: 5,
		r: 5,
		fill: "#00ABFF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.37402 3.33301H5.44629V5.23242H5.41699L4.12305 3.33301H3.33203V6.86816H4.25977V4.95898H4.28418L5.59766 6.86816H6.37402V3.33301Z",
		fill: "white"
	})]
});
export default SvgIconNewTag;
